import { errorLoading, responseHandler, errorGetStatus } from '../manager/HttpManager'
import { fetchLogoutAction } from './AuthWS'
import Constants from '../constants/Constants'

let urlServer = Constants.UrlsConstants.urlCountly

export const analyticsWS = (state = { dashboard: {}, events: {}, event: {} }, action) => {
  switch (action.type) {
    case Constants.ActionsConstants.ANALYTICS.SET_DASHBOARD:
      return Object.assign({}, state, { dashboard: action.datas })
    case Constants.ActionsConstants.ANALYTICS.CLEAR:
      return Object.assign({}, state, { dashboard: action.datas, events: action.datas, event: action.datas })
    case Constants.ActionsConstants.ANALYTICS.SET_EVENTS:
      return Object.assign({}, state, { events: action.datas })
    case Constants.ActionsConstants.ANALYTICS.SET_EVENT_DATAS:
      return Object.assign({}, state, { event: action.datas })
    default:
      return state
  }
}

export const setDashboard = (data) => {
  return {
    type: Constants.ActionsConstants.ANALYTICS.SET_DASHBOARD,
    datas: data,
  }
}

export const clearDatas = () => {
  return {
    type: Constants.ActionsConstants.ANALYTICS.CLEAR,
    datas: {},
  }
}

export const setEvents = (datas) => {
  return {
    type: Constants.ActionsConstants.ANALYTICS.SET_EVENTS,
    datas,
  }
}

export const setEvent = (datas) => {
  return {
    type: Constants.ActionsConstants.ANALYTICS.SET_EVENT_DATAS,
    datas,
  }
}

export function fetchAnalytics (dispatch, appID = null, apiKey = null, event = null) {
  function fetchDashboard () {
    if (appID && apiKey) {
      let method = '/o/analytics/dashboard?app_id='+appID+'&api_key='+apiKey

      fetch(urlServer+method)
        .then(response => {
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          dispatch(setDashboard(data))
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.authFail'))
          }
        })
    }
  }

  function fetchEvents () {
    if (appID && apiKey) {
      let method = '/o?app_id='+appID+'&api_key='+apiKey+'&method=get_events'

      fetch(urlServer+method)
        .then(response => {
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          dispatch(setEvents(data))
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.authFail'))
          }
        })
    }
  }

  function fetchEvent () {
    if (appID && apiKey && event) {
      let method = '/o?app_id='+appID+'&api_key='+apiKey+'&method=events&event='+event

      fetch(urlServer+method)
        .then(response => {
          return responseHandler(response)
        })
        .then(r => r.json())
        .then(data => {
          dispatch(setEvent(data))
        })
        .catch(error => {
          if (errorGetStatus(error) === 401) {
            dispatch(errorLoading('Error.Croutons.authExpired'))
            fetchLogoutAction(dispatch).fetchLogout()
          } else {
            dispatch(errorLoading('Error.Croutons.authFail'))
          }
        })
    }
  }

  function clearAnalytics () {
    dispatch(clearDatas())
  }

  return {
    fetchDashboard,
    fetchEvents,
    fetchEvent,
    clearAnalytics,
  }
}
